<template>
  <v-card outlined class="mt-0">
    <v-card-title>
      เพิ่มคาบเรียน (ปกติ)
      <span class="deep-orange--text ml-2" v-if="has_period_as_default"
        >ตามภาคการศึกษาปกติ</span
      >
      <span class="deep-orange--text ml-2" v-if="!has_period_as_default"
        >ตามที่กำหนด</span
      >
      <v-btn
        outlined
        dense
        small
        color="red"
        class="pa-1 ml-3"
        :disabled="disableButtons"
        @click="
          () => {
            open_period_panel = !open_period_panel;
          }
        "
      >
        <v-icon small class="mr-1">mdi-cog</v-icon> แก้ไขช่วงเวลา
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-alert type="warning" text dense v-if="!has_period_as_default" class="mb-3">
        * ระวัง ระบบไม่ได้ตรวจสอบการกำหนดคาบเรียนในช่วงสอบและช่วงนอกภาคการศึกษา
        *
      </v-alert>
      <v-card outlined v-if="open_period_panel" class="red lighten-5">
        <v-card-text>
          <v-simple-table dense class="mb-5">
            <template v-slot:default>
              <tbody>
                <tr
                  v-for="(item, index) in sorted_opening_periods"
                  :key="index"
                >
                  <td>{{ index + 1 }}.</td>
                  <td>
                    {{
                      item.start_date_time
                        .locale(lang)
                        .format(`dddd D MMMM ${lang == "th" ? "BBBB" : "YYYY"}`)
                    }}
                  </td>
                  <td>{{ item.start_date_time.format("HH:mm") }} น.</td>
                  <td>-</td>
                  <td>
                    {{
                      item.end_date_time
                        .locale(lang)
                        .format(`dddd D MMMM ${lang == "th" ? "BBBB" : "YYYY"}`)
                    }}
                  </td>
                  <td>{{ item.end_date_time.format("HH:mm") }} น.</td>
                  <td>
                    <v-btn
                      small
                      icon
                      color="red"
                      @click="remove_opening_period(index)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <h4 class="ma-3">เพิ่มกรอบเวลาใหม่</h4>
          <v-alert type="warning" text dense v-if="input_opening_period_min_gtt_max" class="mb-3">
            Error: เวลาจบน้อยกว่าเวลาเริ่ม
          </v-alert>
          <v-alert type="warning" text dense v-if="input_opening_period_overlapse" class="mb-3">
            Error: มีข้อมูลเวลาทับซ้อน
          </v-alert>
          <v-form ref="period">
            <v-row dense>
              <v-col cols="12" sm="4">
                <DatePicker
                  label="วันที่เริ่ม"
                  v-model="input_opening_period_start_date"
                ></DatePicker>
              </v-col>
              <v-col cols="12" sm="2">
                <TimePicker
                  label="เวลาเริ่ม"
                  v-model="input_opening_period_start_time"
                ></TimePicker>
              </v-col>
              <v-col cols="12" sm="4">
                <DatePicker
                  label="วันที่จบ"
                  v-model="input_opening_period_end_date"
                ></DatePicker>
              </v-col>
              <v-col cols="12" sm="2">
                <TimePicker
                  label="เวลาจบ"
                  v-model="input_opening_period_end_time"
                ></TimePicker>
              </v-col>
            </v-row>
            <v-btn
              block
              class="white--text"
              color="teal"
              elevation="0"
              small
              @click="period_validate()"
              >เพิ่ม</v-btn
            >
            <v-btn
              block
              outlined
              class="white--text mt-2"
              color="teal"
              elevation="0"
              small
              @click="reset_opening_period()"
              >กลับไปใช้ค่าตั้งต้น</v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>

      <v-divider class="mb-3 mt-2"></v-divider>

      <v-form ref="form">
        <div class="mt-1" v-for="(item, key) in preset_times" :key="item.key">
          <v-alert type="warning" text dense v-if="item.min_gtt_max" class="mb-3">
            Error: เวลาจบน้อยกว่าเวลาเริ่ม
          </v-alert>
          <v-alert type="warning" text dense v-if="item.overlapse" class="mb-3">
            Error: มีข้อมูลเวลาทับซ้อน
          </v-alert>
          <v-row dense>
            <v-col cols="10" sm="4">
              <v-autocomplete
                outlined
                dense
                label="เลือกวันในสัปดาห์"
                v-model="item.day"
                :items="days"
                :item-text="(item) => item.text_th"
                :item-value="(item) => item.value"
                hide-details="auto"
                :rules="requiredRules"
                :disabled="disableButtons"
              ></v-autocomplete>
            </v-col>
            <v-col cols="2" class="d-flex d-sm-none">
              <v-btn icon class="delete-time-button" :ripple="false" color="red" @click="remove_time_preset(key)">
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="3">
              <TimePicker
                label="เวลาเริ่ม"
                v-model="item.start_time"
                :disabled="disableButtons"
              ></TimePicker>
            </v-col>
            <v-col cols="12" sm="3">
              <TimePicker
                label="เวลาจบ"
                v-model="item.end_time"
                :disabled="disableButtons"
              ></TimePicker>
            </v-col>
            <v-col cols="1" class="d-none d-sm-flex">
              <v-btn
                icon
                block
                color="red"
                @click="remove_time_preset(key)"
                :disabled="disableButtons"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <div class="mt-3">
          <v-btn
            small
            class="green white--text"
            elevation="0"
            fab
            aria-label="เพิ่มวัน-เวลาเรียนของรายวิชา"
            title="เพิ่มวัน-เวลาเรียนของรายวิชา"
            @click="add_time_preset()"
            :disabled="disableButtons"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
        <div class="mt-5">
          <v-divider></v-divider>
        </div>
        <div class="mt-3">
          <v-btn
            small
            class="primary white--text"
            @click="validate()"
            :disabled="disableButtons"
            >เพิ่มข้อมูลลงตารางเรียน</v-btn
          >
          <v-btn
            small
            class="red white--text ml-3"
            @click="delete_all_slot()"
            :disabled="disableButtons"
            >ลบคาบเรียนทั้งหมด</v-btn
          >
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import validator from "@/helper/validator";
import TimePicker from "./TimePicker.vue";
import DatePicker from "./DatePicker.vue";
import * as dayjs from "dayjs";
import { populate_date, is_set_overlapse } from "./functions.js";
import { deepEqual } from "@/helper/comparator";
import ConfigTeachTableProvider from "@/services/config_teach_table.provider.js";
const ConfigTeachTableService = new ConfigTeachTableProvider();

export default {
  name: "TimeSlotPresetAdding",
  components: {
    TimePicker,
    DatePicker,
  },
  data: () => ({
    open_period_panel: false,
    opening_periods_default: [
      {
        start_date_time: null,
        end_date_time: null,
      },
      {
        start_date_time: null,
        end_date_time: null,
      },
    ],
    opening_periods: [
      {
        start_date_time: null,
        end_date_time: null,
      },
      {
        start_date_time: null,
        end_date_time: null,
      },
    ],
    all_time_slot: [],
    preset_times: [
      {
        day: null,
        key: Math.random(),
        start_time: null,
        end_time: null,
        overlapse: false,
        min_gtt_max: false,
      },
    ],
    days: [
      { value: "0", text_th: "วันอาทิตย์", text_en: "Sunday" },
      { value: "1", text_th: "วันจันทร์", text_en: "Monday" },
      { value: "2", text_th: "วันอังคาร", text_en: "Tueday" },
      { value: "3", text_th: "วันพุธ", text_en: "Wednesday" },
      { value: "4", text_th: "วันพฤหัสบดี", text_en: "Thursday" },
      { value: "5", text_th: "วันศุกร์", text_en: "Friday" },
      { value: "6", text_th: "วันเสาร์", text_en: "Saturday" },
    ],

    input_opening_period_overlapse: false,
    input_opening_period_min_gtt_max: false,

    input_opening_period_start_date: null,
    input_opening_period_start_time: null,
    input_opening_period_end_date: null,
    input_opening_period_end_time: null,
    requiredRules: [validator.required],
    disableButtons: false,
  }),
  props: {
    levelId: {
      type: [String, Number],
      default: 1,
    },
    current_time_slots: {
      type: Array,
    },
    add_new_time_slot: {
      type: Function,
    },
    delete_all_slot: {
      type: Function,
    },
  },
  computed: {
    lang() {
      if (this.$root.$i18n.locale) return this.$root.$i18n.locale;
      return "th";
    },
    has_period_as_default() {
      return deepEqual(this.opening_periods, this.opening_periods_default);
      //return false;
    },
    sorted_opening_periods() {
      let opening_periods = this.opening_periods;
      return opening_periods.sort(function (a, b) {
        return a.start_date_time.unix() - b.start_date_time.unix();
      });
    },
  },
  methods: {
    //===========================================================
    remove_opening_period(index) {
      this.opening_periods.splice(index, 1);
    },
    //===========================================================
    reset_opening_period() {
      console.log("reset");
      this.opening_periods = this.opening_periods_default.map((a) => ({
        ...a,
      }));
    },
    //===========================================================
    gen_date_from_time(time) {
      return dayjs("2000-01-01 " + time, "YYYY-MM-DD HH:mm");
    },
    //===========================================================
    remove_time_preset(key) {
      this.preset_times.splice(key, 1);
      if (this.preset_times.length === 0) this.add_time_preset();
    },
    //===========================================================
    add_time_preset() {
      this.preset_times.push({
        day: null,
        key: Math.random(),
        start_time: null,
        end_time: null,
        overlapse: false,
        min_gtt_max: false,
      });
    },
    //===========================================================
    validate() {
      if (this.$refs.form.validate()) {
        this.check_time_integrity();
      }
    },
    //===========================================================
    // Main Function to calculate time slots and poppulate them
    check_time_integrity() {
      // check if start time is before end time
      let min_gtt_max = false;
      this.preset_times.map((item) => {
        if (item.start_time > item.end_time) {
          item.min_gtt_max = true;
          min_gtt_max = true;
        }
      });
      if (min_gtt_max) return false;
      //-------------------------------
      // Check if all populated time slot not overlaps with each other
      let all_time_slot = this.current_time_slots;
      let ret_time_slot = [];

      for (let i = 0; i < this.preset_times.length; i++) {
        const preset_time = this.preset_times[i];
        const preset_time_all_time_slot = populate_date(
          preset_time,
          this.opening_periods
        );
        all_time_slot = [...all_time_slot, ...preset_time_all_time_slot];
        ret_time_slot = [...ret_time_slot, ...preset_time_all_time_slot];
        if (is_set_overlapse(all_time_slot)) {
          preset_time.overlapse = true;
          return false;
        } else {
          preset_time.overlapse = false;
        }
      }

      //-----------------------------
      this.add_new_time_slot(ret_time_slot);
      this.$refs.form.reset();
      this.preset_times = [];
      this.add_time_preset();
      return true;
    },
    //===========================================================
    period_validate() {
      if (this.$refs.period.validate()) {
        this.check_period_integrity();
      }
    },
    //===========================================================
    check_period_integrity() {
      const start_date_time = dayjs(
        this.input_opening_period_start_date +
          " " +
          this.input_opening_period_start_time,
        "YYYY-MM-DD HH:mm"
      );
      const end_date_time = dayjs(
        this.input_opening_period_end_date +
          " " +
          this.input_opening_period_end_time,
        "YYYY-MM-DD HH:mm"
      );
      if (end_date_time.unix() < start_date_time.unix()) {
        this.input_opening_period_min_gtt_max = true;
        return false;
      }
      this.input_opening_period_min_gtt_max = false;
      //-------------------------------
      const all_time_slot = [
        ...this.opening_periods,
        { start_date_time, end_date_time },
      ];
      if (is_set_overlapse(all_time_slot)) {
        this.input_opening_period_overlapse = true;
        return false;
      } else {
        this.$refs.period.reset();
        this.input_opening_period_overlapse = false;
        this.opening_periods = all_time_slot;
        return true;
      }
    },

    async getTimeSlotPresetTemp() {
      const level_id = Number(this.levelId) === 2 ? "2" : "1";
      let data;
      try {
        data = await ConfigTeachTableService.getTimeSlotPreset({
          level_id,
          semester: this.$route.query.semester,
          year: this.$route.query.year,
        });
      } catch (error) {
        this.disableButtons = true;
        const responseData = error && error.response && error.response.data;
        const message =
          responseData && responseData.message
            ? responseData.message
            : error && error.message
            ? error.message
            : this.$t("config_teach_table.save_unsuccessfully");
        this.$toasted.error(
          typeof message === "string" ? message : JSON.stringify(message),
          { duration: 0 }
        );
        return;
      }

      this.opening_periods_default[0].start_date_time = dayjs(
        data[0].start_date_time,
        "YYYY-MM-DD HH:mm"
      );
      this.opening_periods_default[0].end_date_time = dayjs(
        data[0].end_date_time,
        "YYYY-MM-DD HH:mm"
      );
      this.opening_periods_default[1].start_date_time = dayjs(
        data[1].start_date_time,
        "YYYY-MM-DD HH:mm"
      );
      this.opening_periods_default[1].end_date_time = dayjs(
        data[1].end_date_time,
        "YYYY-MM-DD HH:mm"
      );

      this.opening_periods[0].start_date_time = dayjs(
        data[0].start_date_time,
        "YYYY-MM-DD HH:mm"
      );
      this.opening_periods[0].end_date_time = dayjs(
        data[0].end_date_time,
        "YYYY-MM-DD HH:mm"
      );
      this.opening_periods[1].start_date_time = dayjs(
        data[1].start_date_time,
        "YYYY-MM-DD HH:mm"
      );
      this.opening_periods[1].end_date_time = dayjs(
        data[1].end_date_time,
        "YYYY-MM-DD HH:mm"
      );
    },
    //===========================================================
  },

  mounted: function () {
    this.getTimeSlotPresetTemp();
  },
};
</script>

<style scoped>
.delete-time-button::before {
  display: none;
}
</style>
